module.exports = __webpack_public_path__ + "img/undraw_Personal_notebook_re_d7dc.b00eed82.svg";